import { ref, watchEffect } from 'vue';

const useCursorPagination = (props) => {
  const itemsPerPage = ref(props.itemsPerPage);
  const activePageCursor = ref(null);
  watchEffect(() => {
    itemsPerPage.value = props.itemsPerPage;
    activePageCursor.value = null;
  });
  const onClickPagination = (pageCursor) => {
    activePageCursor.value = pageCursor != null ? pageCursor : null;
  };
  return {
    itemsPerPage,
    activePageCursor,
    onClickPagination
  };
};

export { useCursorPagination };
